module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "ChapterOpeners_LH-recipe-list-title ParaOverride-1"
  }, [_c('span', {
    staticClass: "RecipeListTitle_lead-in"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }), _c('a', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS1"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("FOREWORD BY David Tanis")]), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }), _c('a', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS1#_idTextAnchor004"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("PRESERVING A WAY OF LIFE")]), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("CHAPTER ONE:")]), _vm._v(" SALT, WIND, AND SUN"), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("CHAPTER TWO:")]), _vm._v(" MISO"), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("CHAPTER THREE:")]), _vm._v(" SOY SAUCE"), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("CHAPTER FOUR:")]), _vm._v(" FISH SAUCE"), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("CHAPTER FIVE:")]), _vm._v(" RICE VINEGAR, SOUR PLUMS,\t\t\t  \tAND PERSIMMONS"), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("CHAPTER SIX:")]), _vm._v(" KOJI, SAKE LEES, AND RICE BRAN"), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("CHAPTER SEVEN:")]), _vm._v(" TOFU, NATTO, AND KONNYAKU"), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("CHAPTER EIGHT:")]), _vm._v(" KATSUOBUSHI,\tKONBU, AND NIBOSHI"), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("CHAPTER NINE:")]), _vm._v(" CHILE PEPPERS AND KIMCHEE"), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("CHAPTER TEN:")]), _vm._v(" SAKE, SHOCHU, AND TEA"), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS22#_idTextAnchor1072",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("AFTERWORD:")]), _vm._v(" THE SNOW OF 2014"), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS22#_idTextAnchor1082",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("ACKNOWLEDGMENTS")]), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS22#_idTextAnchor1085",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("GLOSSARY OF JAPANESE PRODUCE")]), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS22#_idTextAnchor1153",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("FRUITS AND VEGETABLES BY PICKLING METHOD")]), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS22#_idTextAnchor1154",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("FISH AND shellfish BY PICKLING METHOD")]), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS22#_idTextAnchor1156",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("RESOURCES")]), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS22#_idTextAnchor1282",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("BIBLIOGRAPHY")]), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS22#_idTextAnchor1283",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("METRIC CONVERSIONS AND EQUIVALENTS")]), _c('span', {
    staticClass: "CharOverride-1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterOpeners_BL-recipe-list ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    attrs: {
      "href": "#/PreservingJapanese_TESTLINKS22#_idTextAnchor1284",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("INDEX")]), _c('span', {
    staticClass: "CharOverride-1"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-007288a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 60
// module chunks = 0